import * as ko from 'knockout';
import Tagify from '@yaireo/tagify';

ko.bindingHandlers.tagify = 
{
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) 
    {
        // This will be called when the binding is first applied to an element
        // Set up any initial state, event handlers, etc. here
        var value = valueAccessor();
        var options = ko.unwrap(value);

        var current_tags = options.data();

        var tagify_options = 
        {
            id: element.id,
            whitelist: options.whitelist(),
            transformTag: function( tagData ) 
            {
                if(tagData.color)
                    tagData.style = "--tag-bg: white; --tag-text-color: " + tagData.color + "; --tag-hover: " + tagData.color + ";";
            },
            dropdown: 
            {
                enabled: 0,
            },
        };

        if( options.enforceWhitelist )
            tagify_options.enforceWhitelist = true;

        if( options.maxTags )
            tagify_options.maxTags = options.maxTags;

        var tagify = new Tagify(element, tagify_options);
        element.__tagify = tagify;
        element.tagify = tagify;

        tagify.addTags( current_tags );

        tagify.on('add', function(e) 
        {
            value.data.push(e.detail.data);
        });

        tagify.on('remove', function(e) 
        {
            var removed_tag = e.detail.data;
            var list = value.data();

            list = $.grep(list, function(item) { 
                return item.id != removed_tag.id; 
            });

            value.data(list);
        });
    },
};